import React, { useState, useEffect } from "react";
import TimLogo from "../../Assets/TimLogo.png";
import { postAxios } from "../../util/apiCall";
import { useHistory } from "react-router-dom";
import CariBarangIcon from "../../Assets/list_icon.png";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import UnsafeConditionPopup from "../../components/UnsafeConditionPopup/UnsafeConditionPopup";
import CloseLogo from "../../Assets/close_icon.png";
import UcLogo from "../../Assets/uc-logo.png";
import { normalizeRoles, hasRole, formatDot } from "../../util/utilFunction";
import "./MenuComponent.css";

const isMinus = (v) => Number(v) < 0;

const formatSisa = (v) => formatDot(Math.abs(Number(v)));

const hasRoleOutside = (user, ...excluded) => {
  const roles = normalizeRoles(user?.role);
  return roles.length === 0 || roles.some((r) => !excluded.includes(r));
};

const MenuComponent = ({ setMenu, menu }) => {
  let history = useHistory();
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);
  const [openSubMenu, setOpenSubMenu] = useState(false);
  const [isOn, setIsOn] = useState(false);
  const [isReload, setIsReload] = useState(false);

  const [popUpCariBarang, setPopUpCariBarang] = useState(false);
  const [cariBarang, setCariBarang] = useState();

  const [popUpUnsafe, setPopUpUnsafe] = useState(false);

  const [popUpChangePassword, setPopUpChangePassword] = useState(false);
  const [oldPassword, setOldPassword] = useState();
  const [newPassword, setNewPassword] = useState();

  const [code, setCode] = useState();

  const is = (...roles) => hasRole(dataUser, ...roles);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/emergency`,
      { tim: dataUser.tim, dataType: "emergency", type: "get" },
      dataUser.auth,
      setIsOn,
      ""
    );
    setIsReload(false);
  }, [isReload]);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getCariBarang`,
      {
        tim: dataUser.tim,
      },
      dataUser.auth,
      setCariBarang,
      ""
    );
  }, [popUpCariBarang]);

  const handleLogout = () => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/logout`,
      { tim: dataUser.tim, id: dataUser.id },
      dataUser.auth,
      "",
      ""
    );
    localStorage.removeItem("auth");
    history.push("/login");
  };

  const pickMenu = (data) => {
    setMenu(data);
    setOpenSubMenu(false);
  };

  const handlePressToggle = () => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/emergency`,
      {
        tim: dataUser.tim,
        dataType: "emergency",
        type: "edit",
        isToggle: isOn,
      },
      dataUser.auth,
      "",
      ""
    );
    setIsOn(!isOn);
    setIsReload(true);
  };

  const sortData =
    cariBarang &&
    [...cariBarang].sort(function (a, b) {
      if (Number(a.mesin) < Number(b.mesin)) {
        return -1;
      }
      if (Number(a.mesin) > Number(b.mesin)) {
        return 1;
      }
      return 0;
    });

  const handleClose = () => {
    setPopUpCariBarang(false);
    setCariBarang();
  };

  const handleCloseGantiPassword = () => {
    setOldPassword();
    setNewPassword();
    setPopUpChangePassword(false);
    handleLogout();
  };

  const handleChangePassword = () => {
    if (oldPassword && newPassword) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/changePassword`,
        {
          id: dataUser.id,
          oldPassword: oldPassword,
          newPassword: newPassword,
        },
        dataUser.auth,
        setCode,
        ""
      );
      if (code === 200) {
        handleCloseGantiPassword();
        handleLogout();
      }
    }
  };

  // ---------- Hak akses menu ----------
  const tim1 = dataUser.tim === 1;
  const tim2 = dataUser.tim === 2;

  const showUnsafe = tim1;

  const showInOutKendaraan =
    tim1 &&
    is(
      "super_user",
      "warehouse_admin",
      "warehouse_gbj_admin",
      "security",
      "warehouse_user"
    );

  // Home disembunyikan dari role ini (kalau user punya role lain, tetap tampil)
  const showHome = hasRoleOutside(
    dataUser,
    "p3_user",
    "warehouse_admin",
    "warehouse_gbj_admin",
    "warehouse_gbj_user",
    "security"
  );

  const showBon = tim1 && is("super_user");

  const showPenilaianKaryawan = is(
    "super_user",
    "produksi_leader",
    "pr_admin",
    "sp_admin",
    "qc_admin",
    "hrd_admin",
    "warehouse_admin",
    "mesin_admin",
    "mold_admin",
    "ppic_admin"
  );

  const showMrp = tim1 && is("super_user", "ppic_admin");

  const showLkm = is(
    "super_user",
    "produksi_leader",
    "mold_admin",
    "ppic_admin",
    "mold_user",
    "mesin_admin",
    "mesin_user",
    "warehouse_admin",
    "warehouse_mixing",
    "qc_admin"
  );

  const showBpb =
    tim1 &&
    is(
      "super_user",
      "ppic_admin",
      "warehouse_admin",
      "mesin_admin",
      "mold_admin",
      "pr_admin",
      "sp_admin",
      "security",
      "hrd_admin",
      "produksi_leader",
      "document_control",
      "kebersihan_user",
      "finance_admin",
      "qc_admin"
    );

  const showDowntimeGantiProduk = is(
    "super_user",
    "produksi_leader",
    "produksi_admin",
    "ppic_admin",
    "mold_user",
    "mold_admin",
    "qc_user",
    "qc_admin"
  );

  const showRejection = is(
    "super_user",
    "ppic_admin",
    "produksi_admin",
    "qc_admin",
    "sp_admin",
    "pr_admin"
  );

  const showLemburKaryawan = is(
    "super_user",
    "produksi_leader",
    "ppic_admin",
    "mesin_admin",
    "warehouse_admin",
    "mold_admin",
    "qc_admin",
    "pr_admin",
    "sp_admin"
  );

  const showBox = is(
    "super_user",
    "warehouse_admin",
    "warehouse_user",
    "warehouse_gbj_admin"
  );

  const showKarantina = is(
    "super_user",
    "qc_admin",
    "qc_user",
    "sp_admin",
    "sp_user",
    "pr_admin",
    "pr_user",
    "pr_checker",
    "warehouse_gbj_admin",
    "warehouse_admin",
    "produksi_admin",
    "produksi_user",
    "produksi_leader",
    "ppic_admin"
  );

  const showInventory = is(
    "super_user",
    "warehouse_admin",
    "warehouse_gbj_admin",
    "warehouse_mixing",
    "warehouse_crusher",
    "ppic_admin",
    "ppic_user",
    "sp_admin",
    "pr_admin"
  );

  const showInputBahan = is(
    "super_user",
    "warehouse_admin",
    "warehouse_gbj_admin",
    "ppic_admin",
    "ppic_user",
    "warehouse_mixing",
    "warehouse_crusher"
  );

  const showInputBarangJadi = is(
    "super_user",
    "warehouse_admin",
    "ppic_admin",
    "ppic_user",
    "pr_admin",
    "warehouse_gbj_admin"
  );

  // History disembunyikan dari role ini (kalau user punya role lain, tetap tampil)
  const showHistory = hasRoleOutside(
    dataUser,
    "p3_user",
    "produksi_user",
    "pr_user",
    "pr_checker",
    "sp_user",
    "sp_admin",
    "security"
  );

  const showNewMemoPPIC = is("super_user", "ppic_admin");
  const showQC = is("super_user", "qc_admin", "qc_user");
  const showPatrol = is("super_user", "qc_user", "qc_admin", "ppic_admin");
  const showSecurity = is("super_user", "security");

  const showMold = is(
    "super_user",
    "mold_admin",
    "ppic_admin",
    "qc_admin",
    "produksi_admin"
  );

  const showOperator = is("super_user", "produksi_user");

  const showSP = is(
    "super_user",
    "pr_user",
    "pr_checker",
    "produksi_admin",
    "ppic_admin",
    "pr_admin",
    "sp_user",
    "sp_admin",
    "produksi_leader"
  );

  const showPatrolSp = tim1 && is("super_user", "pr_checker", "pr_admin");
  const showListProdukSP = is("super_user", "pr_admin", "sp_admin");
  const showApprovalLaporan = is("super_user", "produksi_leader");
  const showApprovalLaporanSP = is("super_user", "sp_admin", "pr_admin");
  const showCheckSheet = is("super_user", "sp_admin", "pr_admin");

  const showBarcodeYBI =
    (tim1 &&
      is(
        "super_user",
        "pr_admin",
        "sp_admin",
        "warehouse_gbj_admin",
        "ppic_user"
      )) ||
    (tim2 &&
      is(
        "super_user",
        "pr_admin",
        "sp_admin",
        "warehouse_gbj_admin",
        "warehouse_user",
        "ppic_user"
      ));

  const showPO = is(
    "super_user",
    "ppic_admin",
    "ppic_user",
    "warehouse_gbj_admin",
    "finance_admin"
  );

  const showApar = is("super_user", "security");
  const showEmergencyToggle = is("super_user", "ppic_admin");

  // ---------- Daftar menu (urutan = urutan tampil) ----------
  const menuItems = [
    { key: "Dashboard", label: "Home", show: showHome },
    { key: "InputBon", label: "Bon", show: showBon },
    {
      key: "InOutKendaraan",
      label: "In Out Kendaraan",
      show: showInOutKendaraan,
    },
    { key: "SuggestionSystem", label: "SS", show: tim1 },
    {
      key: "PenilaianKaryawan",
      label: "Penilaian Karyawan",
      show: showPenilaianKaryawan,
    },
    { key: "mrp", label: "MRP", show: showMrp },
    { key: "LKM", label: "LKM", show: showLkm },
    { key: "Bpb", label: "BPB", show: showBpb },
    {
      key: "DowntimeGantiProduk",
      label: "Downtime Ganti Produk",
      show: showDowntimeGantiProduk,
    },
    { key: "MonitorKonversiMaterial", label: "Rejection", show: showRejection },
    {
      key: "LemburKaryawan",
      label: "Lembur Karyawan",
      show: showLemburKaryawan,
    },
    { key: "InputBox", label: "Box", show: showBox },
    { key: "Karantina", label: "Karantina", show: showKarantina },
    { key: "Inventory", label: "Inventory", show: showInventory },
    { key: "InputBahan", label: "Input Bahan", show: showInputBahan },
    { key: "InputBarangJadi", label: "Input GBJ", show: showInputBarangJadi },
    { key: "History", label: "History", show: showHistory },
    { key: "NewMemoPPIC", label: "PPIC", show: showNewMemoPPIC },
    { key: "QC", label: "QC", show: showQC },
    { key: "Patrol", label: "Patrol", show: showPatrol },
    { key: "Security", label: "Security", show: showSecurity },
    { key: "Mold", label: "Mold", show: showMold },
    { key: "Operator", label: "Operator", show: showOperator },
    { key: "SP", label: "SP", show: showSP },
    { key: "PatrolSp", label: "Patrol SP", show: showPatrolSp },
    { key: "listProdukSP", label: "Produk SP", show: showListProdukSP },
    {
      key: "ApprovalLaporan",
      label: "Approval Laporan",
      show: showApprovalLaporan,
    },
    {
      key: "ApprovalLaporanSP",
      label: "Approval Laporan SP",
      show: showApprovalLaporanSP,
    },
    { key: "checkSheet", label: "Check Sheet", show: showCheckSheet },
    { key: "BarcodeYBI", label: "Barcode YBI", show: showBarcodeYBI },
    { key: "PO", label: "PO", show: showPO },
    { key: "Apar", label: "APAR", show: showApar },
  ];

  return (
    <>
      {/* ---------- Popup ganti password ---------- */}
      {popUpChangePassword && (
        <PopUpComponent>
          <div className="mc-popup">
            <div className="mc-popup__head">
              <h3 className="mc-popup__title">Ganti password</h3>
              <button
                type="button"
                className="mc-popup__close"
                aria-label="Tutup"
                onClick={() => setPopUpChangePassword(false)}
              >
                <img src={CloseLogo} alt="" />
              </button>
            </div>
            <div className="mc-form">
              <label className="mc-field">
                <span className="mc-field__label">Password lama</span>
                <input
                  className="mc-input"
                  type="password"
                  placeholder="Password lama"
                  value={oldPassword || ""}
                  onChange={(e) => setOldPassword(e.target.value)}
                />
              </label>
              <label className="mc-field">
                <span className="mc-field__label">Password baru</span>
                <input
                  className="mc-input"
                  type="password"
                  placeholder="Password baru"
                  value={newPassword || ""}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </label>
            </div>
            <div className="mc-popup__actions">
              <button
                type="button"
                className="mc-btn mc-btn--danger"
                onClick={() => handleChangePassword()}
              >
                Ganti
              </button>
            </div>
          </div>
        </PopUpComponent>
      )}

      {/* ---------- Popup cari barang ---------- */}
      {popUpCariBarang && (
        <PopUpComponent style={{ marginTop: "calc(100vh - 95vh - 0px)" }}>
          <div className="mc-popup">
            <div className="mc-popup__head">
              <h3 className="mc-popup__title">Cari barang</h3>
            </div>
            <div className="mc-table-wrap">
              <table className="mc-table">
                <thead>
                  <tr>
                    <th>Mc</th>
                    <th>Cust</th>
                    <th>Produk</th>
                    <th>Sisa</th>
                  </tr>
                </thead>
                <tbody>
                  {sortData.map((data, index) => {
                    const minus = isMinus(data.cariBarang);
                    return (
                      <tr
                        key={index}
                        className={minus ? "mc-row--minus" : undefined}
                      >
                        <td style={{ textAlign: "center" }}>{data.mesin}</td>
                        <td style={{ textAlign: "center" }}>{data.customer}</td>
                        <td>{data.moldType}</td>
                        <td>
                          <span
                            className={
                              minus ? "mc-sisa mc-sisa--minus" : "mc-sisa"
                            }
                          >
                            {minus && (
                              <span className="mc-badge">KELEBIHAN</span>
                            )}
                            {formatSisa(data.cariBarang)}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="mc-popup__actions">
              <button
                type="button"
                className="mc-btn"
                onClick={() => handleClose()}
              >
                Tutup
              </button>
            </div>
          </div>
        </PopUpComponent>
      )}

      {popUpUnsafe && (
        <UnsafeConditionPopup onClose={() => setPopUpUnsafe(false)} />
      )}

      {/* ---------- Toolbar mobile ---------- */}
      <div className="mc-toolbar">
        <button
          type="button"
          className="mc-toolbar__menu"
          onClick={() => setOpenSubMenu(!openSubMenu)}
        >
          Menu
        </button>
        <button
          type="button"
          className="mc-icon-btn"
          aria-label="Cari barang"
          onClick={() => setPopUpCariBarang(true)}
        >
          <img src={CariBarangIcon} alt="" />
        </button>
        {showUnsafe && (
          <button
            type="button"
            className="mc-icon-btn"
            aria-label="Unsafe condition"
            onClick={() => setPopUpUnsafe(true)}
          >
            <img src={UcLogo} alt="" />
          </button>
        )}
      </div>

      {/* Klik di luar untuk menutup menu (mobile) */}
      <div
        className={
          openSubMenu ? "mc-backdrop mc-backdrop--show" : "mc-backdrop"
        }
        onClick={() => setOpenSubMenu(false)}
      />

      {/* ---------- Sidebar ---------- */}
      <aside
        className={openSubMenu ? "mc-sidebar mc-sidebar--open" : "mc-sidebar"}
      >
        <div className="mc-brand">
          <img src={TimLogo} className="mc-brand__logo" alt="logo" />

          <div className="mc-brand__actions">
            <button
              type="button"
              className="mc-icon-btn"
              aria-label="Cari barang"
              onClick={() => setPopUpCariBarang(true)}
            >
              <img src={CariBarangIcon} alt="" />
            </button>

            {showUnsafe && (
              <button
                type="button"
                className="mc-icon-btn"
                aria-label="Unsafe condition"
                onClick={() => setPopUpUnsafe(true)}
              >
                <img src={UcLogo} alt="" />
              </button>
            )}
          </div>
        </div>

        <nav className="mc-nav">
          {menuItems
            .filter((item) => item.show)
            .map((item) => (
              <button
                type="button"
                key={item.key}
                className={
                  menu === item.key ? "mc-item mc-item--active" : "mc-item"
                }
                onClick={() => pickMenu(item.key)}
              >
                {item.label}
              </button>
            ))}

          <button
            type="button"
            className="mc-item mc-item--muted"
            onClick={() => setPopUpChangePassword(true)}
          >
            Change Password
          </button>
        </nav>

        <div className="mc-footer">
          {showEmergencyToggle && (
            <label className="mc-switch">
              <span>
                Emergency
                <strong
                  className={
                    isOn
                      ? "mc-switch__state mc-switch__state--on"
                      : "mc-switch__state mc-switch__state--off"
                  }
                >
                  {isOn ? "ON" : "OFF"}
                </strong>
              </span>
              <input
                type="checkbox"
                className="mc-switch__input"
                checked={!isOn}
                onChange={() => handlePressToggle()}
              />
              <span className="mc-switch__track" aria-hidden="true" />
            </label>
          )}
          <button
            type="button"
            className="mc-logout"
            onClick={() => handleLogout()}
          >
            Logout
          </button>
        </div>
      </aside>
    </>
  );
};
export default MenuComponent;
